import { uiStore } from 'shared/store/uiStore'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'

export const openResultsSearch = (value?: string) => {
  const query = new URLSearchParams()

  if (value) {
    query.set('search', value)
  }

  uiStore.changeRoute({
    path: `/${ConversationsPath.search}`,
    query: query.toString(),
  })
}
